// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".launch-service-container {\n  padding: 2rem 18rem 5rem 15rem !important;\n}\n.launch-service-container .launch-service-title {\n  font-size: 1.875rem;\n}\n.clickable-element:hover {\n  cursor: pointer;\n}\n.highlight-instance-row {\n  border: 2px solid #abc74a !important;\n}\n.launch-button {\n  background: #0e9bc0 !important;\n}\n.launch-disabled {\n  background: #A6A4A6 !important;\n  color: #fff !important;\n}\n.launch-disabled span {\n  color: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
